"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmznAntiCsrf = exports.AddToCartButton = exports.ADD_TO_CART_ID = void 0;
const react_1 = __importStar(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const styles_1 = require("./styles");
exports.ADD_TO_CART_ID = 'addToCart-anti-csrf';
const AddToCartButton = ({ callToActionCart, quantity }) => {
    var _a, _b, _c;
    const [configStore, configStoreActions] = (0, monera_app_core_1.useConfigStore)();
    (0, react_1.useEffect)(() => {
        const csrfTokenElement = document.getElementById(exports.ADD_TO_CART_ID);
        if (csrfTokenElement != null && csrfTokenElement.value != null) {
            configStoreActions.update({ addToCartCsrfToken: csrfTokenElement.value });
        }
    }, []);
    const { asin, addToCartCsrfToken } = configStore;
    return callToActionCart != undefined && callToActionCart.addToCart != undefined ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.StyledForm, { action: (_a = callToActionCart === null || callToActionCart === void 0 ? void 0 : callToActionCart.addToCart) === null || _a === void 0 ? void 0 : _a.url, method: "post" },
            addToCartCsrfToken ? (react_1.default.createElement("input", { name: "anti-csrftoken-a2z", type: "hidden", value: addToCartCsrfToken })) : (react_1.default.createElement(exports.AmznAntiCsrf, null)), (_b = callToActionCart === null || callToActionCart === void 0 ? void 0 : callToActionCart.addToCart) === null || _b === void 0 ? void 0 :
            _b.data.parameters.map(({ name, value }) => {
                return react_1.default.createElement("input", { key: name, type: "hidden", name: name, id: name, value: value });
            }),
            react_1.default.createElement("input", { key: "quantity", type: "hidden", name: 'quantity', id: 'quantity', value: quantity }),
            react_1.default.createElement("input", { key: "base-quantity", type: "hidden", name: 'items[0.base][quantity]', value: quantity }),
            react_1.default.createElement("input", { key: "addToCart", type: "hidden", name: 'addToCart', id: 'addToCart', value: 1 }),
            react_1.default.createElement("input", { key: "asin", type: "hidden", name: 'asin', id: 'asin', value: asin }),
            react_1.default.createElement(styles_1.FullWidthButton, { buttonType: "primary", type: "submit" }, (_c = callToActionCart === null || callToActionCart === void 0 ? void 0 : callToActionCart.addToCart) === null || _c === void 0 ? void 0 : _c.data.displayString)))) : null;
};
exports.AddToCartButton = AddToCartButton;
const AmznAntiCsrf = () => {
    return (react_1.default.createElement("div", { dangerouslySetInnerHTML: {
            __html: `<amzn-anti-csrf tag="input" page-type="shopping-cart-add" id="${exports.ADD_TO_CART_ID}"></amzn-anti-csrf>`
        } }));
};
exports.AmznAntiCsrf = AmznAntiCsrf;
__exportStar(require("./types"), exports);
